import React from 'react';
import _ from 'lodash';
import Moment from 'react-moment';
import {CardMedium} from '../widgets/Cards';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { fetchPatients, selectedPatient } from '../../actions';
import { fetchUser} from '../../actions';
import { fetchUserPermissions, fetchPermission } from '../../actions';

class PatientSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchPatient:'',
            patientList: this.props.patients,
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onSelecting = this.onSelecting.bind(this);
    };

    componentDidMount() {
        this.props.fetchPatients();
        this.props.fetchUserPermissions(this.props.currentUserId);
    }

    onInputChange(event) {
        let newPatientList = _.filter(this.props.patients, pt=> pt.lastname.toLowerCase().includes(event.target.value.toLowerCase()) || pt.firstname.toLowerCase().includes(event.target.value.toLowerCase()));
        this.setState({
            searchPatient : event.target.value,
            patientList : newPatientList
        })
    }


    renderPatientList() {
        var permittedPatients = this.props.permissions;
        var arrayPermitted = [];
        permittedPatients.map(pt => {
            arrayPermitted.push(pt.patientId);
            return null;
        })

        // diplaying loader while patients data not received

        if (this.props.patients.length > 0) {
            return this.state.patientList.map(patient => {
            
                if (arrayPermitted.includes(patient._id) === true) {
                    return (
                        <tr key={patient._id}>
                                <td>{patient.title}</td>
                                <td>{patient.firstname}</td>
                                <td>{patient.lastname}</td>
                                <td> <Moment format='DD MMM YYYY'>{patient.dob}</Moment></td>
                                <td>
                                    <Link to={'/UserPage'}>
                                    <button data-patient={patient._id} onClick={this.onSelecting} className='btnew'>Open</button>
                                    </Link>
                                </td>
                        </tr>
                    )

                } else {
                    return (
                        <tr key={patient._id}>
                                <td>{patient.title}</td>
                                <td>{patient.firstname}</td>
                                <td>{patient.lastname}</td>
                                <td> <Moment format='DD MMM YYYY'>{patient.dob}</Moment></td>
                                <td>
                                    <button data-patient={patient._id} className='btdel'>Request</button>
                                
                                </td>
                        </tr>
                    )

                }
        
                
            })
        }
        return (
            <img alt='loading...' src="../../loader.gif" />
        )
    }

    onSelecting = (event) => {
        var val = event.currentTarget.dataset.patient;
        var permittedPatients = this.props.permissions;
        let permit = permittedPatients.find(item => item.patientId === val);
        this.props.fetchPermission(permit._id);
        this.props.selectedPatient(val); 
    }

    render() {

        if (this.props.patients.length > 0) {
            return (
                <div style={{ height:'300px', width:'500px', position: 'fixed', top: '50%', left:'50%', transform: 'translate(-50%,-50%)'}}>
                <CardMedium title='Select Patient' >
                <input type='text' onChange={this.onInputChange} placeholder='Type in last name or first name here ...' />
                <p></p>
                    <table style={{fontSize:'12px'}}>
                        <thead>
                        <tr>
                            <th>Title</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>DOB</th>
                            <th>Actions</th>
                        </tr>  
                        </thead>
                        <tbody>
                        {this.renderPatientList()}
                        </tbody>
                    </table>

                
                </CardMedium>
                </div>
            )
        }

        return (
            <img src='../../../src/loader.gif' alt=""/>
          )
    }
    
}

const mapStateToProps = (state) => {
    return {
        patients : Object.values(state.patients),
        patient : state.selectedPatient,
        permissions : Object.values(state.permissions),
        currentUserId : state.auth.userId,
        selectedPermission : state.selectedPermission,
        isSignedIn: state.auth.isSignedIn
    };
}


export default connect(mapStateToProps, {fetchPatients, selectedPatient, fetchUser, fetchUserPermissions, fetchPermission})(PatientSelect);

